var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQstnIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2z",
    fill: "#1590e0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.739 17.74a.926.926 0 11-1.852 0 .926.926 0 011.852 0zM12.897 14.062v.393c0 .484-.404.876-.905.876-.5 0-.905-.392-.905-.876v-.393c0-1.021.62-1.958 1.58-2.386.922-.41 1.588-1.5 1.588-2.035 0-1.207-1.014-2.189-2.263-2.189-1.248 0-2.263.982-2.263 2.189 0 .483-.405.875-.906.875-.5 0-.905-.392-.905-.875 0-2.172 1.828-3.94 4.074-3.94 2.246 0 4.074 1.768 4.074 3.94 0 1.182-1.061 2.92-2.64 3.626a.878.878 0 00-.529.795z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQstnIcon);
export default __webpack_public_path__ + "static/media/qstn-icon.11380cd48e123fe3e94c25bbd375116c.svg";
export { ForwardRef as ReactComponent };